export default "__VITE_ASSET__s6lR0H4h__"